const Unsubscribed = () => {
  return (
    <main className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full bg-card rounded-xl shadow-sm border p-10 text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center text-2xl">
          ✓
        </div>
        <h1 className="text-xl font-semibold mb-2">You've been unsubscribed.</h1>
        <p className="text-muted-foreground text-sm leading-relaxed">
          You won't receive any more messages from us.
        </p>
      </div>
    </main>
  );
};

export default Unsubscribed;
